import { CommonModule } from '@angular/common';
import {
  Component, inject, input, Signal,
} from '@angular/core';

import { Toast, ToastType } from '../../models/toast.model';
import { ButtonComponent } from '../button/button.component';
import { ButtonCloseComponent } from '../button-close/button-close.component';
import { InlineSvgComponent } from '../inline-svg/inline-svg.component';

import { ToastService } from './toast.service';

@Component({
  selector: 'ui-toast',
  imports: [ CommonModule, InlineSvgComponent, ButtonComponent, ButtonCloseComponent ],
  templateUrl: './toast.component.html',
  styleUrl: './toast.component.scss',
})
export class ToastComponent {
  /** Determines whether the toast container is fixed. */
  fixed = input<boolean>(true);

  /** The current list of toasts to be displayed. */
  toasts: Signal<Toast[]>;
  /** Possible types of toast notifications */
  toastType = ToastType;

  /** A reference to the toast service managing this component. */
  private toastService = inject(ToastService);

  constructor() {
    this.toasts = this.toastService.toasts;
  }

  /** Notification that should be removed from the list. */
  removeToast(toast: Toast): void {
    this.toastService.removeToast(toast);
  }

  /** Runs the toast's action, if any, then dismisses it. */
  onClickButton(toast: Toast): void {
    toast.action?.();
    this.removeToast(toast);
  }
}
